<template>
  <div class="service-fullscreen-layout">
    <v-app>
      <main class="service-fullscreen-scroll">
        <router-view />
      </main>
      <notifications group="notify" position="bottom center" />
    </v-app>
  </div>
</template>

<script>
export default {
  name: "FullscreenLayout",
  mounted() {
    document.documentElement.classList.add("service-fullscreen-document");
    document.body.classList.add("service-fullscreen-document");
  },
  beforeDestroy() {
    document.documentElement.classList.remove("service-fullscreen-document");
    document.body.classList.remove("service-fullscreen-document");
  }
};
</script>

<style scoped>
.service-fullscreen-layout {
  background: #f3f6f9;
  height: 100vh;
  overflow: hidden;
  width: 100vw;
}

.service-fullscreen-scroll {
  background: #f3f6f9;
  height: 100vh;
  overflow: auto;
  width: 100vw;
}
</style>

<style>
.service-fullscreen-layout .v-application,
.service-fullscreen-layout .v-application--wrap {
  height: 100vh;
  max-width: none !important;
  min-width: 100vw;
  overflow: hidden;
  width: 100vw;
}

html.service-fullscreen-document,
body.service-fullscreen-document {
  height: 100%;
  overflow: hidden !important;
}

body.service-fullscreen-document,
body.service-fullscreen-document #app {
  height: 100%;
  min-width: 100vw;
  overflow: hidden;
  width: 100vw;
}

.service-fullscreen-scroll > * {
  min-width: 100%;
  width: max-content;
}
</style>
